import router from '../router'

export function sigin (state, data) {
  state.user.username = data.username
  state.user.role_name = data.role_name
  state.user.token = data.accesstoken
  sessionStorage.setItem('users', JSON.stringify(state.user))
}

export function checkLogin (state) {
  if (state.user.username === null && sessionStorage.getItem('users') === null && sessionStorage.getItem('config') === null) {
    router.push({
      name: 'Login'
    })
  } else {
    state.user = JSON.parse(sessionStorage.getItem('users'))
    state.config = JSON.parse(sessionStorage.getItem('config'))
  }
}

export function setConfig (state, data) {
  state.config = data.config
  sessionStorage.setItem('config', JSON.stringify(state.config))
}

export function logout (state) {
  state.user.username = null
  state.user.role_name = null
  state.config = null
  sessionStorage.clear()
  if (state.user.username === null) {
    router.push({
      name: 'Login'
    })
  }
}



// WEBPACK FOOTER //
// ./src/Vuex/mutations.js